import Alpine from 'alpinejs'
import { obrCalc } from './calculator/state.js'
import { captureUtm } from './utm.js'
import { initReveal } from './reveal.js'
import { initAnchorLanding } from './anchors.js'

// Last-touch obr_utm capture — every page load, before Alpine boots (D-10).
captureUtm()

// Scroll-reveal motion (below-the-fold sections; no-op under prefers-reduced-motion / no IO).
initReveal()

// Wejście na stronę z „#nazwa" w adresie — poprawka pozycji po dojściu obrazów (patrz moduł).
initAnchorLanding()

window.Alpine = Alpine
Alpine.data('obrCalc', obrCalc)
Alpine.start()
